import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/Main.css';
import App from './App.jsx';
import { Amplify } from 'aws-amplify';
import outputs from './aws/aws-exports.js';
Amplify.configure(outputs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

